import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Play } from "lucide-react";

const ytId = (u = "") => (u.match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([A-Za-z0-9_-]{6,})/) || [])[1] || "";
const igCode = (u = "") => (u.match(/instagram\.com\/(?:p|reel|reels|tv)\/([A-Za-z0-9_-]+)/) || [])[1] || "";

/** Media slider that plays YouTube and Instagram inline, and shows plain images. */
export default function MediaSlider({ links = [], testId = "media" }) {
  const [i, setI] = useState(0);
  const [playing, setPlaying] = useState(false);
  const items = (links || []).filter(Boolean);
  if (items.length === 0) return null;
  const cur = items[i % items.length];
  const yt = ytId(cur);
  const ig = igCode(cur);
  const isVideo = !!yt || !!ig || /\.mp4($|\?)/i.test(cur);
  const thumb = yt ? `https://i.ytimg.com/vi/${yt}/hqdefault.jpg` : (!isVideo ? cur : "");
  const go = (d) => { setPlaying(false); setI((v) => (v + d + items.length) % items.length); };

  return (
    <div className="relative mt-3 rounded-2xl overflow-hidden border border-white/10 bg-black/60" data-testid={testId}>
      <div className="aspect-[16/10] w-full">
        {playing && yt && (
          <iframe title="video" src={`https://www.youtube.com/embed/${yt}?autoplay=1`} allow="autoplay; encrypted-media" allowFullScreen
            className="w-full h-full" data-testid={`${testId}-yt`} />
        )}
        {playing && ig && (
          <iframe title="instagram" src={`https://www.instagram.com/p/${ig}/embed`} scrolling="no" allowTransparency="true"
            className="w-full h-full bg-white" data-testid={`${testId}-ig`} />
        )}
        {playing && !yt && !ig && (
          <video src={cur} controls autoPlay className="w-full h-full object-contain" data-testid={`${testId}-video`} />
        )}
        {!playing && (
          <button type="button" onClick={() => (isVideo ? setPlaying(true) : window.open(cur, "_blank", "noopener"))}
            className="w-full h-full block relative" data-testid={`${testId}-open`}>
            {thumb ? <img src={thumb} alt="" loading="lazy" className="w-full h-full object-cover" />
              : <div className="w-full h-full flex items-center justify-center text-xs font-mono uppercase tracking-widest text-white/70">Play reel</div>}
            {isVideo && (
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="tile w-12 h-12"><Play className="w-5 h-5 relative z-10" /></span>
              </span>
            )}
          </button>
        )}
      </div>
      {items.length > 1 && (
        <>
          <button type="button" onClick={() => go(-1)} data-testid={`${testId}-prev`} className="absolute left-2 top-1/2 -translate-y-1/2 icon-circle !w-8 !h-8 !rounded-full bg-black/70"><ChevronLeft className="w-4 h-4" /></button>
          <button type="button" onClick={() => go(1)} data-testid={`${testId}-next`} className="absolute right-2 top-1/2 -translate-y-1/2 icon-circle !w-8 !h-8 !rounded-full bg-black/70"><ChevronRight className="w-4 h-4" /></button>
          <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
            {items.map((_, k) => <span key={k} className={`w-1.5 h-1.5 rounded-full ${k === i % items.length ? "bg-lime" : "bg-white/35"}`} />)}
          </div>
        </>
      )}
    </div>
  );
}
